import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';

import '../styles/Carousel.css';
import "swiper/swiper-bundle.css";

// Importa tus imágenes
import evento from '../assets/images/Inicio/NuestrosEventos/evento.jpg';
import evento1 from '../assets/images/Inicio/NuestrosEventos/evento1.jpg';
import evento3 from '../assets/images/Inicio/NuestrosEventos/evento3.jpg';
import evento4 from '../assets/images/Inicio/NuestrosEventos/evento4.jpg';
import evento5 from '../assets/images/Inicio/NuestrosEventos/evento5.jpg';
import evento6 from '../assets/images/Inicio/NuestrosEventos/evento6.jpg';
import evento7 from '../assets/images/Inicio/NuestrosEventos/evento7.jpg';
import evento8 from '../assets/images/Inicio/NuestrosEventos/evento8.jpg';
import evento9 from '../assets/images/Inicio/NuestrosEventos/evento9.jpg';
import evento10 from '../assets/images/Inicio/NuestrosEventos/evento10.jpg';
import evento11 from '../assets/images/Inicio/NuestrosEventos/evento11.jpg';
import evento12 from '../assets/images/Inicio/NuestrosEventos/evento12.jpg';
import evento13 from '../assets/images/Inicio/NuestrosEventos/evento13.jpg';
import evento14 from '../assets/images/Inicio/NuestrosEventos/evento14.jpg';
import evento15 from '../assets/images/Inicio/NuestrosEventos/evento15.jpg';
import evento16 from '../assets/images/Inicio/NuestrosEventos/evento16.jpg';


const CarouselComponent = () => {
    const images = [
        { url: evento },
        { url: evento1 },
        { url: evento10 },
        { url: evento3 },
        { url: evento4 },
        { url: evento5 },
        { url: evento6 },
        { url: evento7 },
        { url: evento8 },
        { url: evento9 },
        { url: evento11 },
        { url: evento12 },
        { url: evento13 },
        { url: evento14 },
        { url: evento15 },
        { url: evento16 },
    ];

    return (
        <div>
            <Swiper
                modules={[Navigation, Pagination, Autoplay, A11y]}
                spaceBetween={20} // Espacio entre diapositivas
                slidesPerView={1} // Por defecto, 1 diapositiva visible
                centeredSlides={true} // Centrar diapositiva activa
                loop={true} // Carrusel infinito
                autoplay={{ delay: 3000, disableOnInteraction: false }} // Scroll automático
                navigation={true} // Habilitar flechas
                pagination={{ clickable: true }} // Habilitar puntos
                breakpoints={{
                    768: {
                        slidesPerView: 1, // 1 diapositiva en pantallas pequeñas
                        centeredSlides: true,
                    },
                    1024: {
                        slidesPerView: 3, // 3 diapositivas en pantallas grandes
                    },
                }}
            >
                {images.map((photo, index) => (
                    <SwiperSlide key={index}>
                        <div className="slide-container">
                            <img
                                src={photo.url}
                                alt={`Evento ${index + 1}`}
                                className="slide-image"
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default CarouselComponent;